module.exports = __webpack_public_path__ + "static/media/bell-slashed.c0937c3d.svg";